import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaginaPrincipalComponent } from './paginas/pagina-principal/pagina-principal.component';
import { CalendarioGeneralComponent } from './paginas/calendario-general/calendario-general.component';
import { TareasDiaComponent } from './paginas/tareas-dia/tareas-dia.component';
import { Pagina404Component } from './paginas/pagina-404/pagina-404.component';
import { AUTORIZACION_PAGINAS } from '../nucleo/autorizacion/autorizacion.static';
import { Evedisa22Component } from './paginas/evedisa-22/evedisa-22.component';
import { EvedisaMipresComponent } from './paginas/evedisa-mipres/evedisa-mipres.component';

const routes: Routes = [
  {
    path: '',
    component: PaginaPrincipalComponent,
    title: 'Principal',
  },
  {
    path: 'calendario',
    component: CalendarioGeneralComponent,
    title: 'Calendario',
  },
  {
    path: 'tareas-dia',
    component: TareasDiaComponent,
    title: 'Tareas del Día',
    data: { autorizacion: AUTORIZACION_PAGINAS['Tareas del Día'] },
  },
  {
    // CASO ESPECIAL para Evedisa Pereira
    path: 'evedisa-22',
    component: Evedisa22Component,
    title: 'Evedisa 22',
  },
  {
    // CASO ESPECIAL para Evedisa Pereira
    path: 'evedisa-mipres',
    component: EvedisaMipresComponent,
    title: 'Evedisa Mipres',
  },
  {
    path: '**',
    component: Pagina404Component,
    title: 'Página no encontrada',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdhocRoutingModule {}
